'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _login = require('./login.html');

var _login2 = _interopRequireDefault(_login);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

exports.default = {
  templateUrl: _login2.default,
  controller: function () {
    function LoginFormComponent($state, AuthService, ToastService) {
      'ngInject';

      _classCallCheck(this, LoginFormComponent);

      Object.assign(this, { $state: $state, AuthService: AuthService, ToastService: ToastService });
    }

    _createClass(LoginFormComponent, [{
      key: '$onInit',
      value: function $onInit() {
        this.loginEnabled = true;
        this.loginError = {};
      }
    }, {
      key: 'forgotPassword',
      value: function forgotPassword() {
        this.$state.go('forgotPassword', { userName: this.userName });
      }
    }, {
      key: 'onSubmit',
      value: function onSubmit() {
        var _this = this;

        this.loginEnabled = false;
        this.loginError = {};
        this.AuthService.login({
          userName: this.userName,
          password: this.password
        }).then(function () {
          _this.$state.go('app');
        }).catch(function (e) {
          if (e && e.data && e.data.error_description) {
            if (e.data.error_description === 'Invalid Credentials') {
              // const msg = 'The username or password you entered is incorrect.';
              // this.ToastService.showError(e, msg);
              _this.loginError.invalidCredentials = true;
            } else if (e.data.error_description === 'Force Password Reset') {
              _this.$state.go('resetPassword', { userName: _this.userName });
            } else {
              _this.ToastService.showError(e, e.data.error_description);
            }
          } else {
            _this.ToastService.showError(e);
          }

          _this.loginEnabled = true;
        });
      }
    }]);

    return LoginFormComponent;
  }()
};


// WEBPACK FOOTER //
// ./components/auth/login/login.component.js